import React from "react";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Characters from "@/components/Characters";
import Gallery from "@/components/Gallery";
import BooksShelf from "@/components/BooksShelf";
import EduSection from "@/components/EduSection";
import Manifest from "@/components/Manifest";
import Story from "@/components/Story";
import Playground from "@/components/Playground";

export default function Home() {
  return (
    <>
      <Hero />
      <EditorialMarquee />
      <Characters />
      <Gallery />
      <BooksShelf />
      <EduSection />
      <Manifest />
      <Story />
      <Playground />
    </>
  );
}
